import { render, staticRenderFns } from "./AddressBookIcon.vue?vue&type=template&id=20629988&"
import script from "./AddressBookIcon.vue?vue&type=script&lang=js&"
export * from "./AddressBookIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports